<script setup>
import axios from "axios";
import moment from 'moment';
import {reactive, ref} from "vue";
import {ElTabs,ElTabPane,ElButton,ElSelect,ElOption,ElInputNumber,ElLoading,ElDrawer,ElRow,ElCol,ElFormItem,ElForm,ElDatePicker} from "element-plus";
import AirportSearch from "../../Common/AirportSearch.vue";
import ComboFlightList from "./Components/ComboFlightList.vue";
import {
    Search
} from '@element-plus/icons-vue'
import PairFlightList from "./Components/PairFlightList.vue";
import SingleFlightList from "./Components/SingleFlightList.vue";
const emit = defineEmits(['canceli','added','addflight','addflights']);

const props = defineProps({
    form:Object
});

const eform=props.form;


const flightmodel=ref(true);
const searching=ref(false);
const ruleFormRef = ref();

const activeName=ref(0);

const form = reactive({
    source:'',
    destination:'',
    departure_date:eform.departure_date,
    return_date:'',
    pax:{
        adults:eform.adults,
        childs:eform.childs,
        infants:eform.infants
    },
    class:'Economy'

});

if(eform.nights>0){
    form.return_date=moment(eform.departure_date).add(eform.nights,'days').format("YYYY-MM-DD");
}

const rules = reactive({
    source: [
        {required: true, message: 'Required', trigger: ['blur', 'change']}
    ],
    destination: [
        {required: true, message: 'Required', trigger: ['blur', 'change']}
    ],
    departure_date: [
        {required: true, message: 'Required', trigger: ['blur', 'change']}
    ],

});


let result=ref(null);

const submitForm = async (formEl) => {

    if (!formEl) return
    await formEl.validate((valid, fields) => {
        if (valid) {

            loadflights();

        }
    })
}


const loadflights=()=>{
    const loading = ElLoading.service({
        lock: true,
        text: 'Loading',
        background: 'rgba(0, 0, 0, 0.7)',
    });

    axios.post('/flightsapi/search',form)
        .then(function (response) {
            result.value=response.data.data;
            loading.close()
        }).catch(error => {
        loading.close();
    });
}



const addflight=(flight)=>{
    emit('addflight',flight)
}


const addflights=(flight)=>{
    emit('addflights',flight)
}


</script>

<template>
    <el-drawer
        v-model="flightmodel"
        title="Select Flights"
        @closed="emit('canceli')"
        size="90%"
    >
        <el-form
            label-position="top"
            ref="ruleFormRef"
            :model="form"
            status-icon
            :rules="rules"
            v-if="result==null"
        >
            <el-row :gutter="10">
                <el-col :span="4">
                    <el-form-item  label="Source" prop="source">
                        <airport-search   v-model="form.source"   ></airport-search>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item  label="Destination" prop="destination">
                        <airport-search   v-model="form.destination"   ></airport-search>
                    </el-form-item>
                </el-col>
                <el-col :span="3">
                    <el-form-item  label="Departure Date" prop="departure_date">
                        <el-date-picker
                            v-model="form.departure_date"
                            type="date"
                            placeholder="Departure Date"
                            format="DD/MMM/YYYY"
                            value-format="YYYY-MM-DD"
                            style="width:100%"
                        />

                    </el-form-item>
                </el-col>
                <el-col :span="3">
                    <el-form-item  label="Return Date" prop="return_date">
                        <el-date-picker
                            v-model="form.return_date"
                            type="date"
                            placeholder="Return Date"
                            format="DD/MMM/YYYY"
                            value-format="YYYY-MM-DD"
                            clearable
                            style="width:100%"
                        />

                    </el-form-item>
                </el-col>
                <el-col :span="2">
                    <el-form-item  label="Adults" prop="pax.adults">
                        <el-input-number
                            v-model="form.pax.adults"
                            placeholder="Adults"
                            :min="1"
                            style="width:100%"
                            readonly
                        />

                    </el-form-item>
                </el-col>
                <el-col :span="2">
                    <el-form-item  label="Child" prop="pax.childs">
                        <el-input-number
                            v-model="form.pax.childs"
                            placeholder="Child"
                            clearable
                            :min="0"
                            style="width:100%"
                            readonly
                        />

                    </el-form-item>
                </el-col>
                <el-col :span="2">
                    <el-form-item  label="Infants" prop="pax.infant">
                        <el-input-number
                            v-model="form.pax.infants"
                            placeholder="Infants"
                            clearable
                            :min="0"
                            style="width:100%"
                            readonly
                        />

                    </el-form-item>
                </el-col>
                <el-col :span="2">
                    <el-form-item  label="Class" prop="class">
                        <el-select
                            v-model="form.class"
                            placeholder="Class"
                            style="width:100%"
                        >
                            <el-option label="Economy" value="ECONOMY" key="Economy">Economy</el-option>
                            <el-option label="Premium Economy" value="PREMIUM_ECONOMY Economy" key="Premium Economy">Premium Economy</el-option>
                            <el-option label="Business" value="BUSINESS" key="Business">Business</el-option>
                            <el-option label="First Class" value="FIRST" key="First Class">First Class</el-option>
                        </el-select>



                    </el-form-item>
                </el-col>
                <el-col :span="2">
                    <el-form-item  label="" >
                        <el-button style="margin-top:22px" type="primary"  @click="submitForm(ruleFormRef)" :loading="searching" :disabled="searching" >Search </el-button>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>

        <el-tabs v-if="result!=null" v-model="activeName" class="demo-tabs" >
            <el-tab-pane label="Flights" :name="0">





            </el-tab-pane>
            <el-tab-pane label="Combo Flights" :name="1" v-if="result.COMBO">

            </el-tab-pane>

        </el-tabs>

        <div v-if="result!=null">

            <pair-flight-list v-if="result.PAIRS && activeName==0"  :data="result.PAIRS" @addflight="addflights"></pair-flight-list>
            <single-flight-list v-else-if="result.SINGLE && activeName==0"  :data="result.SINGLE" @addflight="addflights"></single-flight-list>

            <combo-flight-list v-else-if="result.COMBO && activeName==1"  :data="result.COMBO" @addflight="addflight"></combo-flight-list>
        </div>
    </el-drawer>
</template>

<style scoped>

</style>
